import { create } from 'zustand';
import { STORAGE_KEYS } from '@/constants/storage';

interface AuthState {
  isAuthenticated: boolean;
  username: string | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: !!localStorage.getItem(STORAGE_KEYS.adminToken),
  username: null,

  login: async (username: string, password: string) => {
    try {
      const { authAPI } = await import('../services/api');
      await authAPI.login(username, password);
      set({ isAuthenticated: true, username });
      return true;
    } catch (error) {
      console.error('Login failed:', error);
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.adminToken);
    set({ isAuthenticated: false, username: null });
  },
}));
